import * as React from "react";

import { IAppMenuFlyoutProps } from "./AppMenuFlyout.types";
import { observer } from "mobx-react";
import { useStyles } from "./AppMenuFlyout.styles";

//To do: after all flyout contents are ready, remove this file.
const AppMenuFlyoutBlankContentBase = (props?: IAppMenuFlyoutProps) => {
    const classNames = useStyles();
    return <div className={classNames.root}>{`${props?.menuItem?.displayName} flyout content`}</div>;
};

export const AppMenuFlyoutBlankContent = observer(AppMenuFlyoutBlankContentBase);
